import { render, staticRenderFns } from "./cart-nano.vue?vue&type=template&id=d29c2044"
import script from "./cart-nano.vue?vue&type=script&lang=js"
export * from "./cart-nano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports